import { useState, useEffect } from 'react';

const PaginationScrollNew = (callback, props) => {
    const [radio, setRadio] = useState(null);
    const [isFetching, setIsFetching] = useState(true);

    const userReachedBottom = () => {
        const scrollPosition = window.scrollY + window.innerHeight;
        const documentHeight = document.documentElement.offsetHeight;
        return scrollPosition >= documentHeight;
    }

    const EventScroll = () => {
        const loading = document.getElementsByClassName('ui text loader')?.length > 0;
        if (userReachedBottom() && !loading) {
            setRadio(1);
        } else {
            setRadio(0)
        }
    }

    useEffect(() => {
        window.addEventListener('scroll', EventScroll);

        return () => {
            window.removeEventListener('scroll', EventScroll);
        };
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        const loading = document.getElementsByClassName('ui text loader')?.length > 0;
        if (radio > 0 && !loading && (props.page > props.current.currentPage + 1)) {
            callback();
        }

        // eslint-disable-next-line
    }, [radio]);

    return [isFetching, setIsFetching];
};

export default PaginationScrollNew;
